import React from 'react'
import {Card, CardHeader, Col, FormGroup, Input, Table,} from "reactstrap";
import Row from "reactstrap/es/Row";
// Strings
import LocalizedStrings from "react-localization";
import {alert_strings} from "../../translations/alert_translations";
import {common_strings} from "../../translations/common_translations";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {Redirect} from "react-router-dom";
import LoadingOverlay from "react-loading-overlay";
import {RotateCircleLoading} from "react-loadingg";
import {report_strings} from "../../translations/report_translations";
import ErrorModal from "../Alerts/ErrorModal";
import reportApiService from "../../api/report-api-service";
import Button from "reactstrap/es/Button";
import pStyles from "../../helpers/style/style_helper";

let alertStrings = new LocalizedStrings(alert_strings);
let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let reportStrings = new LocalizedStrings(report_strings);

const propTypes = {};

export default class NewClients extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numberOfClients: 100,
            clients: null,
            isLoading: false,
        };
    }

    handleChange = this.handleChange.bind(this)
    setMaster = this.setMaster.bind(this)

    componentDidMount() {
        this.getData()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.searchValue !== this.state.searchValue) {
            this.getData()
        }
    }

    toggleErrorModal() {
        this.setState({error: null, showError: false})
    }

    handleNameSelected = selectedOption => {
        this.setState({
                searchValue: selectedOption,
            }
        )
    };

    render() {
        this.localize();

        if (!localStorage.getItem('at') || !localStorage.getItem('business')) {
            return <Redirect from="*" to="/auth/login"/>
        }

        return (
            <LoadingOverlay
                active={this.state.isLoading}
                spinner={<RotateCircleLoading color="white"/>}
                text=''
            >
                <>
                    {this.state.showError &&
                    <ErrorModal showError={this.state.showError} error={this.state.error}
                                toggleErrorModal={() => this.toggleErrorModal()}/>
                    }

                    <Card className="bg-default shadow">
                        <Row style={{marginLeft: 4}}>
                            <Col lg="5">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-last"
                                    >
                                        Number of clients
                                    </label>
                                    <Input
                                        style={{height: "38px"}}
                                        className="form-control-alternative"
                                        defaultValue={this.state.numberOfClients}
                                        value={this.state.numberOfClients}
                                        onChange={this.handleChange}
                                        id="input-last"
                                        type="number"
                                    />
                                </FormGroup>
                            </Col>
                            <Col lg="auto" style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <Button
                                    color="success"
                                    size="lg"
                                    onClick={e => this.handleSubmit(e)}
                                >
                                    GO
                                </Button>
                            </Col>
                        </Row>
                        <Card className="bg-default shadow">
                            <CardHeader className="bg-transparent">
                                <Row>
                                    <h5 className="text-warning mb-0">EVENTS</h5>
                                </Row>
                            </CardHeader>
                            {this.state.clients !== null && this.renderReport()}
                        </Card>
                    </Card>
                </>
            </LoadingOverlay>
        )
    }


    handleChange(event) {
        let newValue = event.target.value;
        let targetId = event.target.id;

        switch (targetId) {
            case "input-id":
                this.setState({userId: newValue});
                break;
            case "input-last":
                this.setState({numberOfClients: newValue});
                break;
            default:
                break;
        }
    }

    renderReport() {
        return (<Col lg="12">
            {this.renderTable()}
        </Col>)
    }

    renderTable() {
        if (this.state.clients !== null) {
            return this.state.clients.map((client, index) => {
                return (
                    <div style={pStyles.reports.reportLine}>
                        <div style={pStyles.reports.reportLineContent}>
                            <div>
                                {client.id}
                            </div>
                            <div style={{marginLeft: 10, display: "flex", flexFlow: "column"}}>
                                <div style={{
                                    fonWeight: 600,
                                    color: (client.name && client.name.includes("(")) ? "yellow" : "white"
                                }}>
                                    {client.name}
                                </div>
                                <div style={{color: "gray"}}>
                                    {client.client_email}
                                </div>
                            </div>

                        </div>

                        <div onClick={e => this.setMaster(e, client.business_id)}>
                            {client.business}
                        </div>
                        <div>
                            <span style={{color: (client.instances && client.instances) > 1 ? "yellow" : "white"}}>
                            {client.instances}
                            </span>
                        </div>
                    </div>
                )
            })
        }
    }

    setMaster(e, business_id) {
        e.preventDefault();

        this.setState({isLoading: true})
        reportApiService.admin_sm(business_id)
            .then(res => {
                this.setState({isLoading: false})
            })
            .catch((e) => {
                this.handleNetworkError(e)
            });
    };

    localize() {
        const loc = localeHelpers.currentLocale();

        reportStrings.setLanguage(loc);
        alertStrings.setLanguage(loc);
        commonStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    getData() {
        if (this.state.searchValue !== null) {
            this.setState({isLoading: true});
            reportApiService.newClients(this.state.numberOfClients)
                .then(res => {
                    this.setState({
                        isLoading: false,
                        clients: res.data
                    });
                })
                .catch((e) => {
                    this.handleNetworkError(e)
                });
        }
    }

    handleNetworkError(e) {
        this.setState({showError: true, error: e, isLoading: false})
    }

    handleSubmit(e) {
        e.preventDefault()
        this.getData()
    }

    onUserIdSelected(e, user_id) {
        e.preventDefault();
        this.setState({userId: user_id})
    }
}

NewClients.propTypes = propTypes;